export default {
  isActive: {
    type: Boolean,
    default: true,
  },
  isHeaderFixed: {
    type: Boolean,
    default: true,
  },
}
